const faqs = [
  {
    q: '桔子影院是否需要注册或付费？',
    a: '完全不需要。桔子影院所有影视内容均可免费在线观看，无需注册账号，无需充值会员，打开网站即点即播，真正做到零门槛观影。',
  },
  {
    q: '观看时为什么不会卡顿缓冲？',
    a: '桔子影院采用智能CDN加速与多线路自适应切换技术，根据你的网络环境自动匹配最优播放节点，确保高清画质下依然流畅播放，告别恼人的缓冲等待。',
  },
  {
    q: '支持哪些设备观看？',
    a: '桔子影院全面适配电脑、平板和手机浏览器。无论你是使用Windows、Mac、iOS还是Android设备，都能获得一致的高清观影体验，随时随地想看就看。',
  },
  {
    q: '内容多久更新一次？',
    a: '平台每日同步更新最新影视内容。热播剧集上线后24小时内即可观看，院线大片下映后也会第一时间更新。我们的内容团队7x24小时监控最新资源。',
  },
  {
    q: '画质最高支持到什么级别？',
    a: '桔子影院提供从流畅到超清的多档画质选择，最高支持1080P全高清画质。部分热门影片更提供4K超高清选项，配合大屏设备带来影院级视觉享受。',
  },
  {
    q: '是否有广告干扰观影？',
    a: '桔子影院坚持以用户体验为先，播放过程中无插播广告，片头片尾干净清爽。我们通过优化技术架构来降低运营成本，而非依赖广告收入影响你的观影体验。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50">常见问题</h2>
          <p className="text-foreground-500 text-sm mt-2">关于桔子影院的常见疑问，这里一一解答</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-300/30"
            >
              <h3 className="text-foreground-100 font-bold text-sm mb-2 flex items-start gap-2">
                <span className="text-primary-400 font-black text-base shrink-0 mt-[-2px]">Q</span>
                {faq.q}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed pl-6">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}